import { createSelector } from 'reselect';

const selectExtraFieldsState = (state: DefaultRootState) => state?.extraFields;

export const selectExtraFields = createSelector(
  [selectExtraFieldsState],
  (extraFields) => extraFields || {}
);

export const selectExtraFieldTypesList = createSelector(
  [selectExtraFieldsState],
  (extraFields) => extraFields?.types || []
);

export const selectVisibleExtraFieldTypesList = createSelector(
  [selectExtraFieldTypesList],
  (extraFieldsList) => extraFieldsList.filter(extraFieldType => !['branch', 'branchService'].includes(extraFieldType.related_to))
);
